// Custom JSX runtime that strips visual-editor `x-*` debug props before
// React forwards them. Used inside Canvas3D where r3f forwards Canvas props
// down to the Three.js scene and crashes on dev attributes.
import { jsx as _jsx, jsxs as _jsxs, Fragment } from "react/jsx-runtime";

function strip(props) {
  if (!props) return props;
  let needs = false;
  for (const k in props) {
    if (k.charCodeAt(0) === 120 && k.charCodeAt(1) === 45) { needs = true; break; }
  }
  if (!needs) return props;
  const out = {};
  for (const k in props) {
    if (!(k.charCodeAt(0) === 120 && k.charCodeAt(1) === 45)) out[k] = props[k];
  }
  return out;
}

export function jsx(type, props, key) {
  return _jsx(type, strip(props), key);
}
export function jsxs(type, props, key) {
  return _jsxs(type, strip(props), key);
}
export { Fragment };
